<template>
  <ValidationObserver
    ref="formValidation"
    v-slot="{ pristine, invalid }"
    slim
  >
    <OpenRegistrationSettingsForm 
      v-model="registrationForm"
    />

    <div class="form-group">
      <div class="col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3">            
        <PrimaryButton
          v-t="'SAVE'"
          size="sm"
          :disabled="pristine || invalid"
          :show-loader-on-form="saveSettingsStatus.status == 'pending'"
          @click="submit"
        />
      </div>
    </div>
  </ValidationObserver>
</template>

<script>

import messages from '../../locales';
import OpenRegistrationSettingsForm from '../OpenRegistrationSettingsForm';
import PrimaryButton from '@/core/components/PrimaryButton';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { mapActions, mapState } from 'vuex';
import { STATUS_ERROR, STATUS_SUCCESS, getStatus } from '@/store/helpers';
import { SAVE_PRP_SETTINGS} from '../../store/actionTypes';

export default {
  components: {
    OpenRegistrationSettingsForm,
    PrimaryButton
  },

  props:{ 
    setting: {
      type: Object,
      default() { 
        return {};
      }
    },
  },

  data: function() {
    return {
      registrationForm: this.setting
    };
  },

  computed: {
    ...mapState('openRegistrationStore', {
      saveSettingsStatus: (state) => getStatus(state, SAVE_PRP_SETTINGS),
    }),
  },

  methods: {
    ...mapActions('openRegistrationStore', [
      SAVE_PRP_SETTINGS,
    ]),
    
    async submit() {
      await this.savePRPSettings(this.registrationForm);

      if (this.saveSettingsStatus.status === STATUS_SUCCESS) {
        utilities.showToaster(STATUS_SUCCESS, this.$i18n.t('PRP_SETTINGS_SAVE_SUCCESS'));
      }
      if (this.saveSettingsStatus.status === STATUS_ERROR) {
        utilities.showToaster(STATUS_ERROR, this.saveSettingsStatus.error);
      }
    }
  },

  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style>

</style>